import {initPhotolabApi} from "./bootstrap/photolab";

const app = {
  container: {},

  /** @return {import("@vicman-wi/photolab-api-js").PhotolabApi} */
  get photolabApi() {
    if (!this.container["photolabApi"]) {
      this.container["photolabApi"] = initPhotolabApi(window.appConfig, window.clientConfig);
    }

    return this.container["photolabApi"];
  },
};

export default app;
